import { parseZonePartnerPayoutFromMetadata } from '../pages/zones/zoneTypes';
import type { PartnerPayoutModel } from '../constants/transportPartnerFlow';

export function zonePartnerPayout(metadata?: Record<string, unknown>): {
  partnerPayoutModel: PartnerPayoutModel;
  commissionRate: number;
} {
  return parseZonePartnerPayoutFromMetadata(metadata);
}

export function zoneSupportsPartnerSubscription(metadata?: Record<string, unknown>) {
  const { partnerPayoutModel } = zonePartnerPayout(metadata);
  return partnerPayoutModel === 'subscription' || partnerPayoutModel === 'both';
}

export function payoutModelLabel(model: PartnerPayoutModel) {
  if (model === 'both') return 'Commission + Subscription';
  if (model === 'subscription') return 'Subscription';
  return 'Commission';
}
